import Form from '../../../components/OrderForm/Form';

import withDefaultProps from './withDefaultProps';

export default withDefaultProps(Form);
